var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("h3", { staticClass: "mb-2" }, [_vm._v("Content")]),
      _c(
        "b-row",
        { staticClass: "align-items-center mb-4" },
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end align-items-center" },
              [
                !_vm.$route.fullPath.includes("view")
                  ? _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "primary" },
                        on: { click: _vm.openFacebookModal },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "text-info mr-1",
                          attrs: { icon: "FacebookIcon", size: "18" },
                        }),
                        _vm._v(" Add Facebook"),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.$route.fullPath.includes("view")
                  ? _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "primary" },
                        on: { click: _vm.openInstagramModal },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "text-danger mr-1",
                          attrs: { icon: "InstagramIcon", size: "18" },
                        }),
                        _vm._v(" Add Instagram"),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.$route.fullPath.includes("view")
                  ? _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "primary" },
                        on: { click: _vm.openLinkedinModal },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "text-info mr-1",
                          attrs: { icon: "LinkedinIcon", size: "18" },
                        }),
                        _vm._v(" Add LinkedIn"),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.$route.fullPath.includes("view")
                  ? _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "primary" },
                        on: { click: _vm.openWhatsappModal },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "16px",
                            height: "16px",
                            "margin-right": "10px",
                          },
                          attrs: {
                            src: require("@/assets/images/logo/whatsapp.png"),
                          },
                        }),
                        _vm._v("Add Whatsapp"),
                      ]
                    )
                  : _vm._e(),
                !_vm.$route.fullPath.includes("view")
                  ? _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "primary" },
                        on: { click: _vm.openEmailModal },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "text-danger mr-1",
                          attrs: { icon: "MailIcon", size: "18" },
                        }),
                        _vm._v(" Add Email"),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.$route.fullPath.includes("view")
                  ? _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "primary" },
                        on: { click: _vm.openEventModal },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "text-info mr-1",
                          attrs: { icon: "CalendarIcon", size: "18" },
                        }),
                        _vm._v(" Add Event"),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.draftId.length === 0
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c(
                        "b-card",
                        [
                          _c("b-card-body", { staticClass: "text-center" }, [
                            _c("h2", [_vm._v("No content available")]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        { staticClass: "mb-4 align-items-center" },
        [
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c("b-form-input", {
                attrs: { placeholder: "Search content...", debounce: 300 },
                model: {
                  value: _vm.searchQuery,
                  callback: function ($$v) {
                    _vm.searchQuery = $$v
                  },
                  expression: "searchQuery",
                },
              }),
            ],
            1
          ),
          _c("b-col", { staticClass: "text-right", attrs: { md: "8" } }, [
            _c("span", { staticClass: "text-muted" }, [
              _vm._v(
                " Showing " +
                  _vm._s(_vm.filteredCost.length) +
                  " of " +
                  _vm._s(_vm.draftId.length) +
                  " contents "
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              items: _vm.paginatedCost,
              fields: _vm.fields,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(createdOn)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(data.item.createdOn)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(publishedDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatDate(data.item.publishedDate)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    !_vm.$route.fullPath.includes("view")
                      ? _c(
                          "b-dropdown",
                          {
                            attrs: {
                              id: "actions-dropdown",
                              variant: "link",
                              size: "sm",
                              text: "Actions",
                              right: "",
                              "no-caret": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("feather-icon", {
                                        staticClass: "align-middle text-body",
                                        attrs: {
                                          icon: "MoreVerticalIcon",
                                          size: "16",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            data.item.status !== "PUBLISHED"
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEditModal(data.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "EditIcon", size: "16" },
                                    }),
                                    _vm._v(" Edit "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            data.item.status == "PUBLISHED"
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewContent(data.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "EyeIcon", size: "16" },
                                    }),
                                    _vm._v(" View "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openCostModal(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "ListIcon", size: "16" },
                                }),
                                _vm._v(" Add Costs "),
                              ],
                              1
                            ),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openTaskModal(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "ListIcon", size: "16" },
                                }),
                                _vm._v(" Add Tasks "),
                              ],
                              1
                            ),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openKpiModal(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "BarChart2Icon", size: "16" },
                                }),
                                _vm._v(" KPI's "),
                              ],
                              1
                            ),
                            data.item.platform !== "Event" &&
                            data.item.status !== "PUBLISHED"
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.postNow(data.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "SendIcon", size: "16" },
                                    }),
                                    _vm._v(" Post Now "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            data.item.status !== "PUBLISHED"
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteCost(
                                          data.item.campaignContentsId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "TrashIcon", size: "16" },
                                    }),
                                    _vm._v(" Delete "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("email-modal", {
            ref: "emailModal",
            on: { "content-updated": _vm.refreshCostTable },
          }),
          _c("facebook-modal", {
            ref: "facebookModal",
            on: { "content-updated": _vm.refreshCostTable },
          }),
          _c("instagram-modal", {
            ref: "instagramModal",
            on: { "content-updated": _vm.refreshCostTable },
          }),
          _c("linkedIn-modal", {
            ref: "linkedinModal",
            on: { "content-updated": _vm.refreshCostTable },
          }),
          _c("whatsapp-modal", {
            ref: "whatsappModal",
            on: { "content-updated": _vm.refreshCostTable },
          }),
          _c("event-modal", {
            ref: "eventModal",
            on: { "content-updated": _vm.refreshCostTable },
          }),
          _c(
            "b-modal",
            {
              ref: "costModal",
              attrs: {
                id: "modal-cost",
                title: "Add Cost",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c(
                "validation-observer",
                { ref: "cost" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.addCost($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Name",
                                    "label-for": "category",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Name",
                                      vid: "Name",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "category",
                                                placeholder: "Name",
                                              },
                                              model: {
                                                value: _vm.newCost.category,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newCost,
                                                    "category",
                                                    $$v
                                                  )
                                                },
                                                expression: "newCost.category",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Description",
                                    "label-for": "description",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Description",
                                      vid: "Description",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "description",
                                                placeholder: "Description",
                                              },
                                              model: {
                                                value: _vm.newCost.description,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newCost,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newCost.description",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Amount",
                                    "label-for": "amount",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Amount",
                                      vid: "Amount",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "amount",
                                                type: "number",
                                                placeholder: "Amount",
                                              },
                                              model: {
                                                value: _vm.newCost.amount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newCost,
                                                    "amount",
                                                    $$v
                                                  )
                                                },
                                                expression: "newCost.amount",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: "Date", "label-for": "date" },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Date",
                                      vid: "Date",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: { id: "date" },
                                              model: {
                                                value: _vm.newCost.date,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newCost,
                                                    "date",
                                                    $$v
                                                  )
                                                },
                                                expression: "newCost.date",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex justify-content-end",
                              attrs: { md: "12" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "submit", variant: "primary" },
                                },
                                [_vm._v("Save Cost")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              ref: "taskModal",
              attrs: {
                id: "modal-task",
                title: "Add Task",
                "hide-footer": "",
                size: "lg",
                centered: "",
              },
              on: { hide: _vm.resetForm },
            },
            [
              _c(
                "validation-observer",
                { ref: "taskForm" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.validateAndSubmit($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Title",
                                    "label-for": "task_title",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required", name: "Title" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "task_title",
                                                placeholder: "Title",
                                              },
                                              model: {
                                                value: _vm.newTask.title,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newTask,
                                                    "title",
                                                    $$v
                                                  )
                                                },
                                                expression: "newTask.title",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Description",
                                    "label-for": "task_description",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Description",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "task_description",
                                                placeholder: "Description",
                                              },
                                              model: {
                                                value: _vm.newTask.description,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newTask,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newTask.description",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Start Date",
                                    "label-for": "start_date",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Start Date",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "start_date",
                                                min: _vm.currentDate,
                                              },
                                              model: {
                                                value: _vm.newTask.startDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newTask,
                                                    "startDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "newTask.startDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "End Date",
                                    "label-for": "end_date",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "End Date",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "end_date",
                                                min:
                                                  _vm.newTask.startDate ||
                                                  _vm.currentDate,
                                              },
                                              model: {
                                                value: _vm.newTask.endDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newTask,
                                                    "endDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "newTask.endDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Assignee(s)",
                                    "label-for": "assignee",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Assignee",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "assignee",
                                                options: _vm.assigneeOptions,
                                              },
                                              model: {
                                                value: _vm.newTask.assigneeId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newTask,
                                                    "assigneeId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newTask.assigneeId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Status",
                                    "label-for": "status",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Status",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.statusOptions,
                                              },
                                              model: {
                                                value: _vm.newTask.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newTask,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "newTask.status",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex justify-content-end",
                              attrs: { md: "12" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "submit", variant: "primary" },
                                },
                                [_vm._v("Add Task")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              ref: "kpiModal",
              attrs: {
                id: "modal-kpi",
                title: "KPI'S",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.saveKpi($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "KPI Name",
                                "label-for": "name1",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "name1",
                                  placeholder: "KPI Name",
                                  required: "",
                                },
                                model: {
                                  value: _vm.kpi.name1,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.kpi, "name1", $$v)
                                  },
                                  expression: "kpi.name1",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "KPI Target",
                                "label-for": "target1",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "target1",
                                  placeholder: "KPI Target",
                                  required: "",
                                },
                                model: {
                                  value: _vm.kpi.target1,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.kpi, "target1", $$v)
                                  },
                                  expression: "kpi.target1",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "KPI Value",
                                "label-for": "value1",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "value1",
                                  placeholder: "KPI Value",
                                  required: "",
                                },
                                model: {
                                  value: _vm.kpi.value1,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.kpi, "value1", $$v)
                                  },
                                  expression: "kpi.value1",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex justify-content-end",
                          attrs: { md: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            { attrs: { type: "submit", variant: "primary" } },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              ref: "editPostModal",
              attrs: {
                id: "modal-edit-post",
                title: "Edit Post",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c(
                "validation-observer",
                { ref: "editPostForm" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.updatePost($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Post Name",
                                    "label-for": "editPostName",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Post Name",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "editPostName",
                                                placeholder: "Enter Post Name",
                                              },
                                              model: {
                                                value:
                                                  _vm.editPostData.postName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editPostData,
                                                    "postName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editPostData.postName",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Budget",
                                    "label-for": "editBudget",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required|numeric",
                                      name: "Budget",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "editBudget",
                                                type: "number",
                                                placeholder: "Enter Budget",
                                              },
                                              model: {
                                                value: _vm.editPostData.budget,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editPostData,
                                                    "budget",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editPostData.budget",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.editPostData.platform !== "WhatsApp"
                            ? _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Content",
                                        "label-for": "editContent",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          rules: "required",
                                          name: "Content",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("quill-editor", {
                                                    attrs: {
                                                      options: _vm.quillOptions,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editPostData
                                                          .content,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.editPostData,
                                                          "content",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editPostData.content",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1327767992
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Status",
                                    "label-for": "editStatus",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Status",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "editStatus",
                                                options: _vm.statusEditOptions,
                                              },
                                              model: {
                                                value: _vm.editPostData.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editPostData,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editPostData.status",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex justify-content-end",
                              attrs: { md: "12" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "submit", variant: "primary" },
                                },
                                [_vm._v("Save Changes")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-pagination", {
            staticClass: "my-2",
            attrs: {
              "per-page": _vm.perPage,
              "total-rows": _vm.draftId.length,
              align: "center",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }